<template>
  <div class="mb-5">
    <div id="header_report_delivery"></div>
    <div id="footer_report_delivery"></div>
    <CRow>
      <CCol col="12">
        <CCard id="body_report_delivery">
          <CCardHeader>
            <strong>{{ $t('components.temporaryReturnDocuments') }}</strong>
            <!--            <FilterHeader ref="filter_bar"/>-->


          </CCardHeader>


          <CCardBody>
            <strong>{{ $t('invoiceDelivery') }}</strong>
            <div style="display: flex">
              <div @click="change_person(item)" v-for="item in persons" :key="item.personId"
                   style="cursor:pointer;margin:2px;width:fit-content;background: #0d6efd;color: white;padding: 4px 5px;border-radius: 10px">
                {{ item.personName }} {{ item.middelName }} {{ item.surName }}
              </div>
            </div>
            <CRow>
              <CCol col="4">
                <treeselect
                    v-model="search_person"
                    :async="search_person_async"
                    :options="search_person_items"
                    :load-options="load_persons"
                    :placeholder="$t('components.searchUser')"
                    :normalizer="normalizer_persons"
                />

              </CCol>
              <CCol col="3">
                <CButton color="dark"
                         @click="get_lists_buy()"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
            <CDataTable
                :items="items_buy"
                :fields="fields"
                hover
                border
                column-filter

                outlined
                :items-per-page="50"
                sorter
                pagination
            >

              <template #row="{item}">

                <td style="text-align: center">
                  <p>{{ item.row_id + 1 }}</p>
                </td>
              </template>

              <template #address="{item}">
                <td style="text-align: center">
                  <p v-if="item.addresses != null && item.addresses.length>0">{{
                      item.addresses[0].cityName + " - " + item.addresses[0].addressText
                    }}</p>
                </td>
              </template>

              <template #docDate="{item}">

                <td>
                  <p>{{ get_date_time(item.docDate) }}</p>

                </td>

              </template>

              <template #warehouse="{item}">
                <td>
                  <p>{{ item.placeName }}</p>

                </td>

              </template>
              <template #masterCode="{item}">
                <td>
                  <p>{{ item.masterCode }}</p>
                </td>
              </template>

              <template #price="{item}">

                <td>
                  <p style="text-align: right" v-if="item.factorTotalPrice !=null">
                    {{ get_currency(item.factorTotalPrice) }}</p>
                  <p style="text-align: right" v-if="item.factorTotalPrice ==null">
                    {{ get_currency("0") }}</p>

                </td>


              </template>

              <template #receive="{item}">

                <td>
                  <p>{{ get_currency(get_payment_total(item)) }}</p>
                </td>
              </template>

              <template #returnAmount="{item}">

                <td>
                  <p>{{ get_currency(get_return_total(item)) }}</p>
                </td>
              </template>

              <template #customer="{item}">

                <td>
                  <p>{{ item.partyName }}</p>

                </td>

              </template>


              <template #operation-header>
                <td>

                  <input type="checkbox" ref="permissions[]" v-model="check_all"/>


                </td>
              </template>
              <template #operation="{item,index}">
                <td>
                  <CButton
                      class="m-1"
                      color="primary"
                      variant="outline"
                      square
                      :title="$t('buttons.show')"
                      size="sm"
                      @click="show_factor_info(item)"
                  >
                    <CIcon name="cil-speedometer"/>
                  </CButton>

                  <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                         :value="item.masterId"/>


                </td>
              </template>

              <template #caption>
                <tr class="total-table">
                  <td>{{ $t('totalCirculation') }}</td>
                  <td></td>
                  <td></td>


                  <td>{{ get_currency(calculate_items(items_buy, 'factorTotalPrice')) }}</td>
                  <td></td>
                  <td></td>

                  <td>{{ get_currency(calculate_items(items_buy, 'total_payed')) }}</td>
                  <td>{{ get_currency(calculate_items(items_buy, 'total_return')) }}</td>
                  <td></td>

                  <td></td>
                </tr>
              </template>

            </CDataTable>
            <strong>{{ $t('returnProducts') }}</strong>

            <CDataTable
                :items="all_products"
                :fields="fields_products"
                border
                column-filter
                :items-per-page="200"

            >

              <template #price="{item}">

                <td>
                  <p>{{ get_currency(item.price) }}</p>
                </td>
              </template>
              <template #caption>
                <tr class="total-table">
                  <td>{{ $t('totalCirculation') }}</td>
                  <td></td>


                  <td>{{ get_currency(calculate_items(all_products, 'total_price')) }}</td>
                  <td></td>

                </tr>
              </template>
            </CDataTable>
            <CRow>
              <CCol>
                <strong>{{ $t('components.sendTempDocsCheque') }}</strong>

                <CDataTable
                    :items="items_cheques"
                    :fields="fields_cheques"
                    border

                    :items-per-page="200"

                >

                  <template #price="{item}">

                    <td>
                      <p>
                        {{ get_currency(item.price) }}</p>

                    </td>
                  </template>
                  <template #price="{item}">
                    <td>
                      <p>
                        {{ get_date(item.checkDate) }}
                      </p>
                    </td>
                  </template>
                </CDataTable>

              </CCol>
            </CRow>


            <CRow>
              <CCol>
                <CCallout color="info">
                  <label>{{ $t('credit') }}</label><br>
                  <strong class="h4">{{ get_currency(all_pay_resid) }}</strong>
                </CCallout>
              </CCol>
              <CCol>
                <CCallout color="info">
                  <label>{{ $t('components.return') }}</label><br>
                  <strong class="h4">{{ get_currency(all_pay_return) }}</strong>
                </CCallout>
              </CCol>
              <CCol>
                <CCallout color="info">
                  <label>{{ $t('components.cash') }}</label><br>
                  <strong class="h4">{{ get_currency(all_pay_cash) }}</strong>
                </CCallout>
              </CCol>
              <CCol>
                <CCallout color="info">
                  <label>{{ $t('components.pos') }}</label><br>
                  <strong class="h4">{{ get_currency(all_pay_ipg) }}</strong>
                </CCallout>
              </CCol>


              <CCol>
                <CCallout color="info">
                  <label>{{ $t('components.check') }}</label><br>
                  <strong class="h4">{{ get_currency(all_pay_check) }}</strong>
                </CCallout>
              </CCol>


            </CRow>
            <br>
          </CCardBody>
          <CCardFooter>

            <CButton
                class="m-1"
                color="primary"
                variant="outline"
                square
                size="sm"
                v-if="get_access('delivery_report_tasvie')"
                @click="tasvie_tozi_konande(0)"
            >{{ $t('buttons.driverCheckout') }}
            </CButton>

            <CButton
                class="m-1"
                color="primary"
                variant="outline"
                square
                v-if="get_access('delivery_report_baigani')"
                size="sm"
                @click="print_with_header('body_report_delivery','header_report_delivery','footer_report_delivery')"
            >{{ $t('buttons.print') }}
            </CButton>


          </CCardFooter>
        </CCard>


      </CCol>
    </CRow>
    <CModal
        :show.sync="show_modal"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="factor_modal.partyName"
        size="lg"
        color="dark"
    >

      <template #header>
        <h6 class="modal-title">{{ $t('components.accountSide') }}: {{ factor_modal.partyName }}</h6>
      </template>

      <template>
        <CRow>
          <CCol col="4">
            <h6 class="modal-title">{{ $t('components.factorId') }}: {{ factor_modal.masterCode }}</h6>

          </CCol>
          <CCol col="4">
            <h6 class="modal-title">{{ $t('components.date') }}: {{ get_date(factor_modal.docDate) }}</h6>

          </CCol>

        </CRow>
        <CCol>
          <CDataTable
              :items="factor_modal.original_products"
              :fields="fields_products_returned"
              :items-per-page="200"
              border
              column-filter>

            <template #ret_qty="{item}">
              <td>
                <CInput class="p-0 m-0" @keyup="calculate_marjoii()" v-model="item.ret_qty"/>

              </td>
            </template>
            <template #qty="{item}">
              <td>
                <p>{{ Math.abs(item.qty) }}</p>
              </td>
            </template>
          </CDataTable>
        </CCol>
        <CRow>
          <CCol>
            <CButton color="primary" @click="temp_payments.push(
                          {chequeInfo:{},masterId:8,paymentType:$t('components.check'),paymentTypeId:3,price:0,summary:''})"
            >
              {{ $t('addCheque') }}
            </CButton>
            <CDataTable
                :items="temp_payments"
                :fields="fields_payments"
                border

                :items-per-page="200"

            >
              <template #row="{item,index}">
                <td>
                  {{ index + 1 }}
                </td>
              </template>

              <template #paymentType="{item}">
                <td v-if="item.paymentTypeId!=5">
                  {{ pay_types.filter(x => x.value == item.paymentTypeId)[0].label }}
                  <!--                  <CSelect :options="pay_types" :value.sync="item.paymentTypeId"/>-->
                  <CSelect :options="terminals" v-if="item.paymentTypeId==1" :value.sync="item.cashBankId"/>
                </td>
                <td v-else>
                  <p>{{ $t('components.return') }}</p>
                </td>
              </template>
              <template #price="{item}">
                <td v-if="item.paymentTypeId!=5 && item.paymentTypeId!=4 ">
                  <CInputCurrency @keyup="calc_resid()" v-model="item.price"/>
                  <CRow v-if="item.paymentTypeId==3">
                    <CCol>
                      <CInput v-model="item.chequeInfo.serial" :label="$t('components.serialNo')"/>

                    </CCol>
                    <CCol>
                      <CInput v-model="item.chequeInfo.ownerName" :label="$t('components.chequeOwner')"/>

                    </CCol>
                    <CCol>
                      <CSelect :label="$t('bankName')" :options="bank_items" :value.sync="item.chequeInfo.bankId"/>

                    </CCol>
                    <CCol col="4">
                      <div>{{ $t('tables.pass_date') }}</div>
                      <date-picker format="jYYYY-jMM-jDD" v-model="item.chequeInfo.checkDate"/>

                    </CCol>
                  </CRow>

                </td>
                <td v-else>
                  <p>{{ get_currency(item.price) }}</p>

                </td>
              </template>
              <template #operation="{item,index}">
                <td>
                  <!--                  <CButton v-if="item.paymentTypeId!=5"-->
                  <!--                           color="primary" @click="temp_payments.splice(index,1)">-->
                  <!--                    <CIcon name="cil-minus"></CIcon>-->
                  <!--                  </CButton>-->

                </td>
              </template>
            </CDataTable>

          </CCol>
        </CRow>


      </template>

      <template #footer>

        <CButton
            @click="show_modal = false"
            color="success"
        >{{ $t('buttons.close') }}
        </CButton>

        <CButton
            @click="show_modal = false,update_payment_types()"
            color="warning"
        >{{ $t('buttons.edit') }}
        </CButton>

      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import FilterHeader from "../includes/FilterHeader";
import Vue from 'vue';

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}


export default {
  name: 'Login',
  components: {
    // FilterHeader,
    Treeselect,
  },
  data() {
    return {

      check_all: false,
      id_checkbox_items: [],
      bank_items: [],
      temp_payments: [],
      pay_types: [
        {label: this.$t('components.cash'), value: 2},
        {label: this.$t('components.pos'), value: 1},
        {label: this.$t('components.resid'), value: 4},
        {label: this.$t('components.check'), value: 3},
      ],
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      file: '',
      color: '#ffffff',
      show_modal: false,
      factor_modal: '',
      previewImage: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,

      all_pay_cash: 0,
      all_pay_check: 0,
      all_pay_return: 0,
      all_pay_ipg: 0,
      all_pay_resid: 0,

      description: null,
      terminals: [],
      items_buy: [],
      items_cheques: [],
      fields_cheques: [
        {key: 'price', label: this.$t('tables.amount')},
        {key: 'owner', label: this.$t('tables.owner')},
        {key: 'bank', label: this.$t('tables.bank')},
        {key: 'serial', label: this.$t('tables.serial')},
        {key: 'checkDate', label: this.$t('tables.date')},
      ],

      fields: [


        {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'masterCode', label: this.$t('tables.factorId'), _style: ''},
        {key: 'customer', label: this.$t('customer'), _style: ''},
        {key: 'price', label: this.$t('tables.amount')},
        {key: 'address', label: this.$t('address')},
        {key: 'docDate', label: this.$t('tables.date'), _style: ''},

        {key: 'receive', label: this.$t('tables.receiveAmount'), _style: ''},
        {key: 'returnAmount', label: this.$t('returnAmount'), _style: ''},
        {key: 'operation', label: this.$t('tables.operation'), _style: ''},

      ],

      fields_products: [
        {key: 'productName', label: this.$t('components.productName'), _style: 'width:30%'},
        // {key: 'masterCode', label: this.$t('tables.factorId'), _style: ''},

        // {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        // {key: 'ret_qty', label: this.$t('returnedQty'), _style: 'width:10%'},
      ],
      fields_products_returned: [
        {key: 'productName', label: this.$t('components.productName'), _style: 'width:30%'},
        // {key: 'masterCode', label: this.$t('tables.factorId'), _style: ''},

        {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        {key: 'ret_qty', label: this.$t('returnedQty'), _style: 'width:10%'},
      ],
      fields_payments: [
        {key: 'row', label: this.$t('tables.row')},
        {key: 'paymentType', label: this.$t('tables.type')},
        {key: 'price', label: this.$t('tables.amount')},
        {key: 'operation', label: this.$t('tables.operation')},


      ],
      details: [],
      persons: [],
      all_payments: [],
      all_products: [],
      templates_items: [],
      collapseDuration: 0,
      status_form: 0,
      search_person: null,
      search_person_async: true,
      search_person_items: [],
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },
    }
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_terminals()
    this.get_bank()
    this.get_persons()

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });

  },
  watch: {
    'search_person': function () {
      this.get_lists_buy();

    },
    'id_checkbox_items': function () {
      var self = this
      var selected_items = []
      self.items_buy.forEach(function (val) {
        if (self.id_checkbox_items.includes(val.masterId)) {
          selected_items.push(val)
        }
      })
      selected_items.forEach(function (val) {
        val.total_payed = self.get_payment_total(val)
        val.total_return = self.get_return_total(val)
      })
      self.items_cheques = []

      self.all_payments = []

      self.all_products = []

      selected_items.forEach(basket => { //(2)
        basket.payments.forEach(pays => { //(2)
          if (pays.paymentType == "چک") {
            var obj = {
              'price': pays.price,
              'paymentType': pays.chequeInfo.paymentType,
              'owner': pays.chequeInfo.ownerName,
              'serial': pays.chequeInfo.serial,
              'checkDate': pays.chequeInfo.checkDate,
              'bank': pays.chequeInfo.bankId
            }
            self.items_cheques.push(obj);
          }


          var exist = false;
          self.all_payments.forEach((val) => {
            if (val.paymentType == pays.paymentType) { //(4)
              exist = true;
              val.price = val.price + pays.price;
            }
          });
          if (!exist) {
            var dup_arr = {price: pays.price, paymentType: pays.paymentType, paymentTypeId: pays.paymentTypeId};
            self.all_payments.push(dup_arr);
          }


        });
      });
      //***************************************88

      selected_items.forEach(basket => { //(2)
        if (basket.products != null) {
          basket.products.forEach(pros => { //(2)

            var exist = false;
            self.all_products.forEach((val) => {
              if (val.productId == pros.productId) { //(4)
                exist = true;
                val.qty = val.qty + pros.qty;
              }
            });
            if (!exist) {
              var dup_arr = JSON.stringify(pros);
              self.all_products.push(JSON.parse(dup_arr));
            }


          });
        }

      });

      self.all_products.forEach((val) => {
        val.total_price = val.qty * val.price
      });
      self.all_pay_cash = 0
      self.all_pay_check = 0
      self.all_pay_return = 0
      self.all_pay_ipg = 0
      self.all_pay_resid = 0

      self.all_payments.forEach((val) => {
        if (val.paymentTypeId == 4) {
          self.all_pay_resid = val.price;
        }
        if (val.paymentTypeId == 3) {
          self.all_pay_check = val.price;
        }

        if (val.paymentTypeId == 2) {
          self.all_pay_cash = val.price;
        }
        if (val.paymentTypeId == 1) {

          self.all_pay_ipg = val.price;
        }

      });

      self.all_products.forEach((val) => {
        self.all_pay_return += val.qty * val.price;

      });

    },

    'check_all': function () {

      const self = this
      if (this.check_all == false) {
        this.id_checkbox_items = []

      } else {
        this.id_checkbox_items = []
        this.items_buy.forEach(function (val) {
          self.id_checkbox_items.push(val.masterId)
        })
      }
    },
    'factor_modal.original_products': function () {
      this.calculate_marjoii();
    },
    'temp_payments': function () {
      this.calc_resid()
    }
  },
  methods: {
    change_person(item) {
      var self = this
      this.search_person = item.personId

      this.search_person_async = false
      this.search_person_items = [
        {
          userId: item.personId,
          personCode: item.personName,
          userName: item.middelName,
          surName: item.surName,
        }
      ]

      setTimeout(function () {
        self.search_person_async = true
      }, 300)
    },
    calc_resid() {
      let total_price = 0
      this.temp_payments.forEach(function (val) {
        if (val.paymentTypeId != 4) {
          if (val.price != '') {
            total_price += parseFloat(val.price)

          }
        }
      })

      this.temp_payments.filter(x => x.paymentTypeId == 4)[0].price = parseFloat(this.factor_modal.factorTotalPrice) - (total_price)

    },
    show_factor_info(item) {
      var self = this
      this.factor_modal = item;
      var pays = JSON.parse(JSON.stringify(this.factor_modal.payments))
      // pays=pays.filter(x => x.paymentTypeId != 4);
      if (pays.filter(x => x.paymentTypeId == 1).length == 0) {
        pays.push({
          chequeInfo: {},
          masterId: 8,
          paymentType: this.$t('components.pos'),
          paymentTypeId: 1,
          price: 0,
          summary: ''
        })
      }
      if (pays.filter(x => x.paymentTypeId == 2).length == 0) {
        pays.push({
          chequeInfo: {},
          masterId: 8,
          paymentType: this.$t('components.cash'),
          paymentTypeId: 2,
          price: 0,
          summary: ''
        })
      }
      if (pays.filter(x => x.paymentTypeId == 4).length == 0) {
        pays.push({
          chequeInfo: {},
          masterId: 8,
          paymentType: this.$t('components.resid'),
          paymentTypeId: 4,
          price: 0,
          summary: ''
        })
      }


      this.temp_payments = pays
      // this.calc_resid();


      this.get_document_details()
    },
    calculate_marjoii() {
      let ret_total = 0
      if (this.factor_modal.original_products == null) {
        return 0
      }
      this.factor_modal.original_products.forEach(function (val) {
        if (val.ret_qty != 0) {
          ret_total += (parseFloat(val.price) / parseInt(val.value)) * parseInt(val.ret_qty)
        }
      })
      if (this.temp_payments.filter(x => x.paymentTypeId == 5).length > 0) {
        this.temp_payments.filter(x => x.paymentTypeId == 5)[0].price = ret_total.toFixed(0)
      } else {
        this.temp_payments.push(
            {
              "paymentType": this.$t('components.return'),
              "price": ret_total.toFixed(0),
              "paymentTypeId": 5,
              "summary": "",
              "cashBankId": 0,
              "chequeInfo": null
            }
        )
      }
      this.calc_resid();
      console.log("calculate_marjoii called", ret_total.toFixed(0))
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_persons() {
      var self = this;

      const formData = new FormData();

      axios.post('GetProductRetPersons', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.persons = content_data.data
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_terminals() {
      var self = this;

      const formData = new FormData();

      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.terminals = self.sort_array(
              [{label: 'Select', value: '0'}], response.data.data,
              'id', 'terminalTitle');

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_payment_total(item) {
      // Pass the element id here
      var total = 0;
      item.payments.filter(x => x.paymentTypeId != 5).forEach((val) => {
        total += (val.price);

      });
      return total;

    },
    get_bank() {
      var self = this;

      const formData = new FormData();

      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = [{label: self.$t('select'), value: 0}];
          self.bank_items = self.sort_array(self.bank_items, content_data.data, 'id', 'bankTitle')

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_return_total(item) {
      // Pass the element id here
      var total = 0;
      item.payments.filter(x => x.paymentTypeId == 5).forEach((val) => {
        total += (val.price);

      });
      return total;

    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists_buy() {
      var self = this;


      const formData = new FormData();

      var url = "GetProductRetsByPersonId";


      formData.append("id", this.search_person);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.id_checkbox_items = []
          self.items_buy = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_buy.forEach(function (val) {
            val.payments.forEach(function (pays) {
              if (pays.chequeInfo == null) {
                pays.chequeInfo = {}
              }
            })
          })
          self.items_buy.forEach(function (val) {
            val.total_payed = self.get_payment_total(val)
            val.total_return = self.get_return_total(val)
          })
          // self.items_buy = self.items_buy.reverse()
          self.items_cheques = []

          self.all_payments = []

          self.all_products = []

          self.items_buy.forEach(basket => { //(2)
            basket.payments.forEach(pays => { //(2)
              if (pays.paymentType == "چک") {
                var obj = {
                  'price': pays.price,
                  'paymentType': pays.chequeInfo.paymentType,
                  'owner': pays.chequeInfo.ownerName,
                  'serial': pays.chequeInfo.serial,
                  'checkDate': pays.chequeInfo.checkDate,
                  'bank': pays.chequeInfo.bankId
                }
                self.items_cheques.push(obj);
              }


              var exist = false;
              self.all_payments.forEach((val) => {
                if (val.paymentType == pays.paymentType) { //(4)
                  exist = true;
                  val.price = val.price + pays.price;
                }
              });
              if (!exist) {
                var dup_arr = {price: pays.price, paymentType: pays.paymentType, paymentTypeId: pays.paymentTypeId};
                self.all_payments.push(dup_arr);
              }


            });
          });
          //***************************************88

          self.items_buy.forEach(basket => { //(2)
            if (basket.products != null) {
              basket.products.forEach(pros => { //(2)

                var exist = false;
                self.all_products.forEach((val) => {
                  if (val.productId == pros.productId) { //(4)
                    exist = true;
                    val.qty = val.qty + pros.qty;
                  }
                });
                if (!exist) {
                  var dup_arr = JSON.stringify(pros);
                  self.all_products.push(JSON.parse(dup_arr));
                }


              });
            }

          });

          self.all_products.forEach((val) => {
            val.total_price = val.qty * val.price
          });
          self.all_pay_cash = 0
          self.all_pay_check = 0
          self.all_pay_return = 0
          self.all_pay_ipg = 0
          self.all_pay_resid = 0

          self.all_payments.forEach((val) => {
            if (val.paymentTypeId == 4) {
              self.all_pay_resid = val.price;
            }
            if (val.paymentTypeId == 3) {
              self.all_pay_check = val.price;
            }

            if (val.paymentTypeId == 2) {
              self.all_pay_cash = val.price;
            }
            if (val.paymentTypeId == 1) {

              self.all_pay_ipg = val.price;
            }

          });

          self.all_products.forEach((val) => {
            self.all_pay_return += val.qty * val.price;

          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", self.factor_modal.masterId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          let fact_pros = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          fact_pros.forEach((val) => {
            // console.log("total weight is ",val.docWeight,val.qty,val.value)
            val.price = val.price * val.value
            val.takhfif = val.discount
            if (self.factor_modal.products.filter(x => x.productId == val.productId).length > 0) {
              val.ret_qty = self.factor_modal.products.filter(x => x.productId == val.productId)[0].qty
            } else {
              val.ret_qty = 0
            }
          });
          Vue.set(self.factor_modal, 'original_products', fact_pros)
          setTimeout(function () {
            self.show_modal = true;

          }, 300)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    update_ret_products() {
      var self = this;


      const formData = new FormData();

      var url = "AddProductRet";
      let items = []


      this.factor_modal.original_products.forEach(function (val) {
        if (val.ret_qty != "" && val.ret_qty != 0 && val.ret_qty != null) {
          let obj = {
            ProductId: val.productId,
            Qty: val.ret_qty,
            MasterId: self.factor_modal.masterId,
            Summary: ""

          }
          items.push(obj)

        }

      })

      formData.append("model", JSON.stringify({products: items, recId: self.factor_modal.masterId}));
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      console.log("items", items)
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.get_lists_buy()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_payment_types() {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorPaymentType";
      let items = []

      this.temp_payments.forEach(function (val) {
        if (val.price != 0) {
          let obj = {
            Price: val.price,
            PaymentType: val.paymentTypeId,
            MasterId: self.factor_modal.masterId,
            PersonId: localStorage.getItem('user_id'),
            Summary: '',
          }
          if (val.paymentTypeId == 1) {
            obj.CashBankId = val.cashBankId
          }
          if (val.paymentTypeId == 3) {
            obj.BankId = val.chequeInfo.bankId
            obj.Serial = val.chequeInfo.serial
            obj.OwnerName = val.chequeInfo.ownerName
            obj.CheckDate = val.chequeInfo.checkDate
          }
          items.push(obj)
        }

      })

      formData.append("model", JSON.stringify({items: items}));
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      console.log("items", items)
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.update_ret_products()


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    return_products_and_resid() {
      var self = this;


      const formData = new FormData();
      if (this.id_checkbox_items.length == 0) {
        return
      }
      var url = "AddFactorRetResult";

      for (var i = 0; i < this.id_checkbox_items.length; i++) {
        formData.append("Factors[]", this.id_checkbox_items[i]);

      }
      formData.append("DriverId", this.search_person);
      // formData.append("VisitorId", this.search_person);

      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.get_lists_buy();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goReturnDocument(item, index) {

      this.$router.push({
        path: '/dashboard/documents/return/' + item.masterId + "/true",
        params: {passed_data: "salam hamidddd"}
      });
      // this.$router.push({name: 'برگشت-سند' ,params: { return_driver: true,doc_id:item.masterId }});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    AddRefer(item, index) {
      this.submit_refer = item.recId;
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.masterFactorId;

    },
    tasvie_tozi_konande(index) {


      let self = this;
      const formData = new FormData()
      let url;
      url = "FactorSettlementByPersonId";

      if (this.items_buy.length == 0) {
        return
      }
      if (this.id_checkbox_items.length == 0) {
        return
      }
      formData.append('personId', this.search_person);
      // formData.append('ids[]', this.items_buy[index].masterId);
      formData.append('ids[]', this.id_checkbox_items[index]);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          self.status_form = 0;
          if (index < self.id_checkbox_items.length - 1) {
            self.tasvie_tozi_konande(index + 1)
          } else {
            self.get_lists_buy();

          }
        } else {
          self.$root.modal_component.show_danger_modal("خطا", "فاکتور به درستی تسویه نگردید. شماره فاکتور:" + self.items_buy[index].masterCode);


          self.get_lists_buy();
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "CancelFactorRefer";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    insert_refer() {

      if (this.refer_person == null) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "AddFactorRefer";
      // }


      formData.append('MasterFactorId', this.submit_refer);
      formData.append('PersonId', this.refer_person);
      axios.post(url, formData, {}).then((res) => {


        self.submit_refer = 0;
        self.refer_person = null;
        // self.color = '';
        // self.description = '';
        // self.previewImage = '';
        // self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  },

}

</script>
